<template>
  <button
    class="btn"
    v-on="$listeners">
    <slot/>
  </button>
</template>

<script>
export default {
  name: 'Button',
};
</script>

<style lang="scss" scoped>
@import '~spectre.css/src/buttons';
</style>



// WEBPACK FOOTER //
// src/components/ui/Button.vue